import consumer from "./consumer"

// This class manages the WebSocket subscription to the NotificationChannel
// It's designed to be used by the notifications Stimulus controller
export class NotificationSubscription {
  constructor(callbacks = {}) {
    this.callbacks = callbacks
    this.subscription = null
  }

  // Subscribe to the notification channel
  subscribe() {
    if (this.subscription) {
      console.warn("Already subscribed to NotificationChannel")
      return this.subscription
    }

    this.subscription = consumer.subscriptions.create("NotificationChannel", {
      connected: () => {
        console.log("Connected to NotificationChannel")
        if (this.callbacks.connected) {
          this.callbacks.connected()
        }
      },

      disconnected: () => {
        console.log("Disconnected from NotificationChannel")
        if (this.callbacks.disconnected) {
          this.callbacks.disconnected()
        }
      },

      rejected: () => {
        console.error("NotificationChannel subscription was rejected")
        if (this.callbacks.rejected) {
          this.callbacks.rejected()
        }
      },

      received: (data) => {
        console.log("Received notification data:", data)

        switch (data.action) {
          case "notification_created":
            if (this.callbacks.notificationCreated) {
              this.callbacks.notificationCreated(data.notification)
            }
            break
          case "marked_as_read":
            if (this.callbacks.markedAsRead) {
              this.callbacks.markedAsRead(data)
            }
            break
          case "marked_all_as_read":
            if (this.callbacks.markedAllAsRead) {
              this.callbacks.markedAllAsRead(data)
            }
            break
          case "dismissed":
            if (this.callbacks.dismissed) {
              this.callbacks.dismissed(data)
            }
            break
          default:
            console.warn("Unknown action received:", data.action)
        }
      }
    })

    return this.subscription
  }

  // Unsubscribe from the notification channel
  unsubscribe() {
    if (this.subscription) {
      consumer.subscriptions.remove(this.subscription)
      this.subscription = null
      console.log("Unsubscribed from NotificationChannel")
    }
  }

  // Mark a notification as read via the channel
  markAsRead(notificationId) {
    if (!this.subscription) {
      console.error("Not subscribed to NotificationChannel")
      return
    }

    this.subscription.perform("mark_as_read", {
      notification_id: notificationId
    })
  }

  // Mark all notifications as read via the channel
  markAllAsRead() {
    if (!this.subscription) {
      console.error("Not subscribed to NotificationChannel")
      return
    }

    this.subscription.perform("mark_all_as_read")
  }

  // Dismiss a notification via the channel
  dismiss(notificationId) {
    if (!this.subscription) {
      console.error("Not subscribed to NotificationChannel")
      return
    }

    this.subscription.perform("dismiss", {
      notification_id: notificationId
    })
  }
}

export default NotificationSubscription
